import type { Metadata } from "next";
import BrowseInfluencerListing from '@/Component/Brand/BrowseInfluencer/BrowseInfluencerListing';

export const metadata: Metadata = {
    title: "Browse Influencer | Connector Club",
    description: "",
};

const BrowseInfluencerPage = () => {
  return (
    <BrowseInfluencerListing />
  )
}

export default BrowseInfluencerPage
